var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-TimeLine"},[_c('el-button',{on:{"click":_vm.preplanDeduction}},[_vm._v("预案推演")]),_c('el-button',{on:{"click":_vm.confirm}},[_vm._v("确定")]),_c('canvas',{ref:"canvas",staticClass:"canvas",on:{"mousewheel":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onMouseweel.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }